
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import { SchoolTemplateNewsTypeEnum } from "@/constants/enum.constant";
import { AxiosResponse } from "axios";

import News1 from "@/components/content-management/news/News1.vue";
import News2 from "@/components/content-management/news/News2.vue";
import News4 from "@/components/content-management/news/News4.vue";

@Component({
  components: {
    News4,
    News2,
    News1,
  },
  filters,
})
export default class News extends Vue {
  @Action("getSchoolNews", { namespace: "school" })
  private getSchoolNews: any;

  @Prop({ default: null })
  private title!: string;
  @Prop({ default: null })
  private params!: any;
  @Prop({ default: 1 })
  private templateNumber!: number;

  private news: Array<any> = [];
  private page = 1;
  private isLastPage = false;
  private isLoading = false;

  private getData(isReload: boolean = false) {
    if (isReload) {
      this.news = [];
      this.page = 1;
      this.isLastPage = false;
    }
    if (!this.isLoading && !this.isLastPage) {
      this.getSchoolNews({
        params: {
          page: this.page,
          label: this.params?.school_news_label_id,
          is_admin: this.params?.type === SchoolTemplateNewsTypeEnum.ADMIN,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.page;
          this.news = [...this.news, ...response.data.data.data];
          this.page = isLastPage ? this.page : this.page + 1;
          this.isLastPage = isLastPage;
        },
      });
    }
  }

  private created() {
    this.getData();
  }
}
